import { render, staticRenderFns } from "./approvalInstances.vue?vue&type=template&id=d71ceffe&scoped=true&"
import script from "./approvalInstances.vue?vue&type=script&lang=js&"
export * from "./approvalInstances.vue?vue&type=script&lang=js&"
import style0 from "./approvalInstances.vue?vue&type=style&index=0&id=d71ceffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d71ceffe",
  null
  
)

export default component.exports